export default __webpack_public_path__ + "static/media/img-mwa-3.5cfa4090.png";